<template>
  <div>
    <AccountLink :sign-in-notification-experience="signInNotificationExperience" />
    <AccountLink
      link-text="My Account - Sign in or Register"
      is-mobile-only
      mounting-point-selector="[data-js='mobile-nav-login-link']"
      :create-button-experience="createButtonExperience"
    />
  </div>
</template>

<script>
import { AccountLink } from '@rei/account-flyout';

export default {
  name: 'AccountLinkFragment',
  components: {
    AccountLink,
  },
  props: {
    createButtonExperience: {
      type: String,
      default: 'control',
    },
    signInNotificationExperience: {
      type: String,
      default: 'control',
    },
  },
};
</script>
